import { Box, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  contactHref?: string;
};

/** @public */
export const TopPlanNote = ({ contactHref = 'mailto:support@torquetitan.ai' }: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant="body1">{t('subscription.topPlan.title', "You're on the top plan.")}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t('subscription.topPlan.subtitle', "Questions or need custom terms? We're happy to chat.")}
        </Typography>
      </Stack>
      <Link href={contactHref}>{t('subscription.topPlan.contactSupport', 'Contact support →')}</Link>
    </Box>
  );
};
